// extracted by mini-css-extract-plugin
module.exports = {"button":"FollowButton_button__2A6YQ","inner_desktop":"FollowButton_inner_desktop__1raHK","inner_mobile":"FollowButton_inner_mobile__15FVO","loading":"FollowButton_loading__3RkFl"};